export default __webpack_public_path__ + "static/media/podcasts_icon_black.a8b6ba9c.svg";